const devicesRegExps = {
	ios: new RegExp('iPad|iPhone|iPod'),
	mobile: new RegExp('Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini')
};

export const recognizedDevices = {};

const deviceClasses = {
	ios: 'v2-ios-device',
	mobile: 'v2-mobile-device'
};

export const deviceDetection = {
	ios: 'ios',
	mobile: 'mobile'
};

export function addDeviceDocumentClass(device) {
	document.documentElement.classList.add(deviceClasses[device]);
}

export function removeDeviceDocumentClass(device) {
	document.documentElement.classList.remove(deviceClasses[device]);
}

export function isDevice(device) {
	if (device in recognizedDevices) {
		return recognizedDevices[device];
	}

	recognizedDevices[device] =
		!!navigator.platform &&
		devicesRegExps[device] &&
		(devicesRegExps[device].test(navigator.platform) ||
			devicesRegExps[device].test(navigator.userAgent));
	return (
		!!navigator.platform &&
		devicesRegExps[device] &&
		(devicesRegExps[device].test(navigator.platform) ||
			devicesRegExps[device].test(navigator.userAgent))
	);
}
